import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { AngularModule, MaterialModule } from '@shared/modules';

@Component({
  selector: 'app-input-positive-number-only',
  standalone: true,
  imports: [AngularModule, MaterialModule],
  templateUrl: './input-positive-number-only.component.html',
  styleUrl: './input-positive-number-only.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPositiveNumberOnlyComponent {
  numberValue!: number;
  label = input.required<string>();
  control = input.required<FormControl>();
  isClear = input<boolean>(true);

  minLength = input<number>(0);
  maxLength = input<number>(Infinity);

  clearInput = output<void>();
  minLengthError = output<void>();

  clear(): void {
    this.control().setValue('');
    this.clearInput.emit();
  }

  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    const currentValue = Number(input.value);

    // Permitir teclas de control
    if (this.isControlKey(key)) {
      return;
    }

    // Bloquear valores negativos al hacer scroll
    if (key === 'ArrowDown' && currentValue <= 0) {
      event.preventDefault();
      return;
    }

    // Bloquear incremento si excede el maxLength
    if (key === 'ArrowUp' && currentValue.toString().length >= this.maxLength() && currentValue >= Number('9'.repeat(this.maxLength()))) {
      event.preventDefault();
      return;
    }

    // Bloquear decremento si excede el maxLength
    if (key === 'ArrowDown' && currentValue.toString().length >= this.maxLength()) {
      event.preventDefault();
      return;
    }

    // Verificar si es un número
    if (!this.isNumber(key)) {
      event.preventDefault();
      return;
    }

    // Verificar longitud máxima al escribir manualmente
    if (currentValue.toString().length >= this.maxLength()) {
      event.preventDefault();
      return;
    }
  }

  onInputChange(): void {
    const currentValue = this.control().value;

    // Corregir valores negativos ingresados manualmente
    if (currentValue < 0) {
      this.control().setValue(0);
      return;
    }

    // Verificar longitud máxima y limitar el valor al máximo permitido
    const maxAllowedValue = Number('9'.repeat(this.maxLength()));
    if (currentValue > maxAllowedValue) {
      this.control().setValue(maxAllowedValue);
      return;
    }
  }

  private isNumber(key: string): boolean {
    return /^\d$/.test(key);
  }

  private isControlKey(key: string): boolean {
    return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab', 'Dead'].includes(key);
  }
}
